export const EcoCreditsRightIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
            <path
                d="M5.87099 10.1053C2.50257 11.7895 1.52011 14.0351 0.818359 15.5789L1.23941 16C2.50257 14.3158 3.15519 12.669 7.97625 10.5263C11.7657 8.8421 14.292 4.91228 15.1341 3.36842L12.6078 0C11.9061 2.66667 9.23941 8.42105 5.87099 10.1053Z"
                fill="url(#paint0_linear_1362_1023)"
            />
            <path
                d="M15.3786 8.06648C13.2512 9.13019 12.6307 10.5485 12.1875 11.5235L12.4534 11.7895C13.2512 10.7258 13.6634 9.68568 16.7083 8.3324C19.1016 7.26869 20.6972 4.7867 21.2291 3.81163L19.6335 1.6842C19.1903 3.36841 17.5061 7.00276 15.3786 8.06648Z"
                fill="url(#paint1_linear_1362_1023)"
            />
            <defs>
                <linearGradient id="paint0_linear_1362_1023" x1="13.871" y1="0.421052" x2="0.81836" y2="15.1579" gradientUnits="userSpaceOnUse">
                    <stop offset="0.3" stopColor="#FAE281" />
                    <stop offset="0.46" stopColor="#E87F30" />
                    <stop offset="0.64" stopColor="#FAE281" />
                </linearGradient>
                <linearGradient id="paint1_linear_1362_1023" x1="20.4313" y1="1.95013" x2="12.1875" y2="11.2576" gradientUnits="userSpaceOnUse">
                    <stop offset="0.3" stopColor="#FAE281" />
                    <stop offset="0.46" stopColor="#E87F30" />
                    <stop offset="0.64" stopColor="#FAE281" />
                </linearGradient>
            </defs>
        </svg>
    );
};
